import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  FINANCIAL_CONSENTS_DATA_SHARING_PATH,
  FINANCIAL_CONSENTS_DATA_SHARING_SUCCESS_PATH,
  FINANCIAL_CONSENTS_DEFINITIONS_PATH,
  FINANCIAL_CONSENTS_MCAF_EDIT_PATH,
  FINANCIAL_CONSENTS_MCAF_PATH,
  FINANCIAL_CONSENTS_MCAF_SUCCESS_PATH,
  FINANCIAL_CONSENTS_PATH,
  FINANCIAL_CONSENTS_TERM_AND_CONDITIONS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const FinancialConsentsPage = lazy(() => import('./pages/FinancialConsentsPage'));
const MCAFPage = lazy(() => import('./pages/MCAFPage'));
const DataSharingPage = lazy(() => import('./pages/DataSharingPage'));
const DefinitionsPage = lazy(() => import('./pages/DefinitionsPage'));
const TermAndConditionsPage = lazy(() => import('./pages/TermAndConditionsPage'));
const SuccessPage = lazy(() => import('./pages/SuccessPage'));

export const FINANCIAL_CONSENTS_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <FinancialConsentsPage />,
    displayTitle: () => 'Financial Consents',
    pageType: PageType.PRIVATE,
    path: FINANCIAL_CONSENTS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.financialConsents,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MCAFPage />,
    displayTitle: () => 'Medical Claims Authorisation Form',
    pageType: PageType.PRIVATE,
    path: FINANCIAL_CONSENTS_MCAF_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.financialConsents,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <MCAFPage isAmend />,
    displayTitle: () => 'Medical Claims Authorisation Form',
    pageType: PageType.PRIVATE,
    path: FINANCIAL_CONSENTS_MCAF_EDIT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.financialConsents,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <DataSharingPage />,
    displayTitle: () => 'Consent For Data-Sharing',
    pageType: PageType.PRIVATE,
    path: FINANCIAL_CONSENTS_DATA_SHARING_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.financialConsents,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <TermAndConditionsPage />,
    displayTitle: () => 'Terms and Conditions',
    pageType: PageType.PRIVATE,
    path: FINANCIAL_CONSENTS_TERM_AND_CONDITIONS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.financialConsents,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <DefinitionsPage />,
    displayTitle: () => 'Definitions',
    pageType: PageType.PRIVATE,
    path: FINANCIAL_CONSENTS_DEFINITIONS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.financialConsents,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <SuccessPage isMCAF />,
    displayTitle: () => 'MCAF(M) - Medical Claims Authorisation Form (Multiple)',
    pageType: PageType.PRIVATE,
    path: FINANCIAL_CONSENTS_MCAF_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.financialConsents,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <SuccessPage />,
    displayTitle: () => 'Consent For Data-Sharing',
    pageType: PageType.PRIVATE,
    path: FINANCIAL_CONSENTS_DATA_SHARING_SUCCESS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.financialConsents,
  },
];
